<!-- horizontal 横 -->
<template>
  <div class="columns is-horizontal is-6-desktop is-multiline">
    <div class="column is-one-third" v-for="(item, index) in items" :key="index" @click="item.path ? goNext(item):''">
      <!-- 图片在右边 -->
      <div class="card card-horizontal is-clickable" tabindex="0"
        :style="{ background: item.bg_color ? item.bg_color : '', cursor: item.path ?'pointer':'' }"
        v-if="item.position == 2">
        <div class="card-content" :class="{ hasImg: item.image }">
          <h4 class="title is-4">{{ item.title }}</h4>
          <div class="subtitle subtitle_page_html has-text-justified has-text-grey-darker" v-html="item.desc">
          </div>
        </div>
        <div class="card-image column is-hidden-touch">
          <figure class="image is-5by3">
            <!-- image -->
            <template v-if="item.banner_type == 1">
              <img v-if="item.image" :src="item.image" class="banner_img" />
            </template>
            <!-- mp4 -->
            <template v-else-if="item.banner_type == 2">
              <video class="home_video_page" v-if="item.mp4_url" id="home_video_page" controls loop muted>
                <source :src="item.mp4_url" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </template>
            <!-- Yutube -->
            <template v-else-if="item.banner_type == 3">
              <div class="iframe-wrap-card" v-html="item.video_url"></div>
            </template>
          </figure>
        </div>
      </div>

      <!-- 图片在左边 -->
      <div class="card card-horizontal is-clickable" tabindex="0"
        :style="{ background: item.bg_color ? item.bg_color : '', cursor: item.path ? 'pointer' : '' }" v-else>
        <div class="card-image column is-hidden-touch">
          <figure class="image is-5by3">
            <!-- image -->
            <template v-if="item.banner_type == 1">
              <img v-if="item.image" :src="item.image" class="banner_img" />
            </template>
            <!-- mp4 -->
            <template v-else-if="item.banner_type == 2">
              <video class="home_video" v-if="item.mp4_url" id="home_video" controls loop muted>
                <source :src="item.mp4_url" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </template>
            <!-- Yutube -->
            <template v-else-if="item.banner_type == 3">
              <div class="iframe-wrap-card" v-html="item.video_url"></div>
            </template>
          </figure>
        </div>
        <div class="card-content" :class="{ hasImg: item.image }">
          <h4 class="title is-4">{{ item.title }}</h4>
          <p class="subtitle subtitle_page_html has-text-justified has-text-grey-darker" v-html="item.desc">
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      default: [],
      type: Array,
    },
  },
  data() {
    return {
      selectedDirectory: null
    };
  },
  async mounted() {
    setTimeout(()=>{
      var screenWidth = window.innerWidth;
      var iframe = document.getElementsByTagName("iframe");
      if (iframe) {
        for (let i = 0; i <= iframe.length - 1; i++) {
          iframe[i].style.width = "100%";
          iframe[i].style.height = "100%";
        }
      }
      var iframe_wrap = document.getElementsByClassName("iframe-wrap-card");
      if (iframe_wrap) {
        for (let i = 0; i <= iframe_wrap.length - 1; i++) {
          if (screenWidth >= 769) {
            iframe_wrap[i].style.height = "300px";
          } else {
            iframe_wrap[i].style.height = "200px";
          }
        }
      }
    }, 0)
  },
  methods: {
    goNext(item) {
      // this.$router.push({
      //   path: item.path,
      // });
      window.location.href = item.path;
    },
  },
};
</script>

<style scoped>
.card {
  background-color: #fff;
  border-radius: 6px;
  color: #757763;
  max-width: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
}

.card-horizontal {
  display: flex;
  justify-content: space-between;
}

.card-image {
  display: flex;
  position: relative;
  padding: 10px;
}

.card-image img {
  max-width: 100%;
}

.title.is-4 {
  font-size: 1.5rem;
}

.title {
  color: #363636;
  font-family: Rubik, sans-serif;
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.125;
  margin-bottom: 1.5rem;
}

.hasImg .title {
  text-align: left;
}

.subtitle {
  color: #757763;
  font-size: 16px;
  line-height: 1.25;
  font-weight: 600 !important;
  margin-top: 4px;
  text-align: left;
}

.column {
  padding: 24px;
  box-sizing: border-box;
}

.columns {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -1.5rem;
}

.columns:last-child {
  margin-bottom: -1.5rem;
}

.columns.is-multiline {
  flex-wrap: wrap;
}

.columns.is-variable {
  --columnGap: 0.75rem;
  margin-left: calc(-1 * var(--columnGap));
  margin-right: calc(-1 * var(--columnGap));
}

.columns.is-variable > .column {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.card-content {
  background-color: transparent;
  padding: 24px;
  flex: 1;
}

.tag:not(body).is-rounded {
  border-radius: 9999px;
}

.tag:not(body).is-large {
  font-size: 20px;
}

.tag:not(body).is-primary {
  background-color: #de4c50;
  color: #fff;
}

.mt-4 {
  margin-top: 16px !important;
}

.tag {
  font-weight: 800;
}

.tag:not(body) {
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 4px;
  color: #757763;
  display: inline-flex;
  font-size: 12px;
  height: 32px;
  justify-content: center;
  line-height: 1.5;
  padding-left: 12px;
  padding-right: 12px;
  white-space: nowrap;
}

.lead {
  text-align: center;
}

.mr-4 {
  margin-right: 16px !important;
}

.tag:not(body).is-rounded {
  border-radius: 290486px;
}

.tag:not(body).is-medium {
  font-size: 1rem;
}

.tag:not(body).is-danger {
  background-color: #de4c50;
  color: #fff;
}

.tag {
  font-weight: 800;
}

.tag:not(body) {
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 4px;
  color: #757763;
  display: inline-flex;
  font-size: 0.75rem;
  height: 2em;
  justify-content: center;
  line-height: 1.5;
  padding-left: 0.75em;
  padding-right: 0.75em;
  white-space: nowrap;
}

.tag:not(body).is-info {
  background-color: #276cda;
  color: #fff;
}

.mr-2 {
  margin-right: 0.5rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.is-clickable {
  pointer-events: all !important;
}

.card-image:first-child img {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.mr-0 {
  margin-right: 0 !important;
}

.image {
  display: flex;
  position: relative;
  width: 100%;
  align-items: center;
}

.image img {
  display: block;
  height: auto;
  max-height: 320px;
}

.has-text-weight-medium {
  font-weight: 500 !important;
}

@media screen and (max-width: 768px) {
  .is-hidden-mobile {
    display: none !important;
  }
}

@media screen and (min-width: 769px) {
  .column.is-one-third,
  .column.is-one-third-tablet {
    flex: none;
    width: 100%;
  }

  .is-hidden-tablet {
    display: none !important;
  }

  .columns:not(.is-desktop) {
    display: flex;
  }

  .column.is-one-third,
  .column.is-one-third-tablet {
    flex: none;
    width: 100%;
  }
}

@media screen and (min-width: 1024px) {
  .columns.is-variable.is-6-desktop {
    --columnGap: 1.5rem;
  }
}

@media screen and (min-width: 1408px) {
}

.image {
  display: flex;
  position: relative;
  align-items: center;
}

.has-text-grey-darker {
  color: #363636 !important;
}

.has-text-justified {
  text-align: justify !important;
}
.card-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.home_video {
  width: 600px;
}
.iframe-wrap-card {
  width: 600px;
  display: flex;
  align-items: center;
}
.iframe-wrap-card iframe {
  width: 600px !important;
  height: 300px !important;
}
</style>
<style>
.subtitle_page_html p {
  word-break: break-word !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Card/PageList.vue